import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "إشعار ملفات تعريف الارتباط",
    description:
      "نستخدم ملفات تعريف الارتباط الأساسية لضمان أن يعمل هذا الموقع بشكل صحيح. نستخدم أيضًا ملفات تعريف الارتباط الاختيارية للتتبع لمساعدتنا على فهم كيفية تفاعلك مع موقعنا. لن يتم تعيين هذه الملفات الاختيارية إلا بموافقتك.",
    acceptAllBtn: "قبول الكل",
    acceptNecessaryBtn: "رفض الكل",
    showPreferencesBtn: "إدارة التفضيلات الفردية",
  },
  preferencesModal: {
    title: "إدارة تفضيلات ملفات تعريف الارتباط",
    acceptAllBtn: "قبول الكل",
    acceptNecessaryBtn: "رفض الكل",
    savePreferencesBtn: "قبول التحديد الحالي",
    closeIconLabel: "إغلاق النافذة",
    sections: [
      {
        title: "استخدام ملفات تعريف الارتباط",
        description:
          "نستخدم ملفات تعريف الارتباط لدعم الوظائف الأساسية لهذا الموقع ولتحسين تجربة التصفح لديك.",
      },
      {
        title: "ملفات تعريف الارتباط الضرورية تمامًا",
        description:
          "تُعد ملفات تعريف الارتباط هذه ضرورية للتشغيل السليم للموقع، على سبيل المثال لمصادقة المستخدم.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "الاسم",
            domain: "الخدمة",
            description: "الوصف",
            expiration: "مدة الصلاحية",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "ملف تعريف الارتباط يتم تعيينه بواسطة منصة المجتمع الرقمي لمصادقة المستخدم.",
              expiration: "الجلسة",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "ملف تعريف الارتباط يتم تعيينه بواسطة منصة المجتمع الرقمي لمصادقة المستخدم",
              expiration: "الجلسة",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "يُستخدم ملف تعريف الارتباط هذا للتمييز بين البشر والروبوتات لحماية الموقع من إساءة الاستخدام الآلي. لا يتم جمع أي بيانات شخصية.",
              expiration: "30 دقيقة",
            },
          ],
        },
      },
      {
        title: "التحليلات",
        description:
          "تُستخدم ملفات تعريف الارتباط الخاصة بالتحليلات لجمع بيانات تمكّن الخدمات من فهم كيفية تفاعل المستخدمين مع خدمة معينة. تساعد هذه الرؤى في تحسين المحتوى وبناء ميزات أفضل لتحسين تجربة المستخدم.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "الاسم",
            domain: "الخدمة",
            description: "الوصف",
            expiration: "مدة الصلاحية",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'ملف تعريف الارتباط يتم تعيينه بواسطة <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "تنتهي بعد 12 يومًا",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'ملف تعريف الارتباط يتم تعيينه بواسطة <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "الجلسة",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "يتيح تخزين البيانات المتعلقة بالتحليلات مثل مدة الزيارة.";

export { translation, servicesLabel };
